import { useCallback, useEffect, useRef } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { MarqueeStrip } from "@/components/MarqueeStrip";
import { WinterBanner } from "@/components/WinterBanner";
import { Manifesto } from "@/components/Manifesto";
import { Services } from "@/components/Services";
import { Projects } from "@/components/Projects";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    lenisRef.current = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  const scrollTo = useCallback((selector) => {
    const el = document.querySelector(selector);
    if (el && lenisRef.current) {
      lenisRef.current.scrollTo(el, { offset: -64, duration: 1.5 });
    }
  }, []);

  return (
    <div className="App bg-[#050505] text-[#F2F2F2] min-h-screen" data-testid="app-root">
      <div className="grain" aria-hidden="true" />
      <Navbar onNavigate={scrollTo} />
      <main>
        <Hero onNavigate={scrollTo} />
        <MarqueeStrip />
        <WinterBanner onNavigate={scrollTo} />
        <Manifesto />
        <Services />
        <Projects />
        <Contact />
      </main>
      <Footer onNavigate={scrollTo} />
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
